import { useMemo } from "react";
import { FlatNodeItem } from "@components/common/tree-view/Interfaces";
import { useLang } from "@hooks/useLang";
import * as S from "./TreeItem.styled";

export const TreeItem = (props: FlatNodeItem) => {
  const { label, metaData, licenseStatus, parent } = props;
  const { translate } = useLang();
  const ChipList = useMemo(() => {
    const chips = [];
    if (!parent) {
      if (licenseStatus && licenseStatus !== "Normal") {
        // license
        chips.push(
          <S.Chip color="var(--system-gray)">{translate("no_license")}</S.Chip>
        );
      }

      // AI rules
      if (typeof metaData?.enabledAiRule !== "undefined") {
        const metaDataStatus = metaData.enabledAiRule
          ? translate("on")
          : translate("off");

        chips.push(
          <S.Chip
            data-testid="channel-status"
            color={`${
              metaDataStatus === "on"
                ? "var(--system-emerald)"
                : "var(--system-gray)"
            }`}
          >
            {translate("ai")} {metaDataStatus.toUpperCase()}
          </S.Chip>
        );
      }
    }

    return chips;
  }, [licenseStatus, metaData?.enabledAiRule, parent]);

  return (
    <>
      <S.Title>{label}</S.Title>
      <S.ChipsWrap>
        {ChipList.map((v, index) => {
          return (
            <>
              {index > 0 && <S.Divider />}
              {v}
            </>
          );
        })}
      </S.ChipsWrap>
    </>
  );
};
